<template>
  <section id="featured-homes" style="position:relative">
    <v-container class="text-center">
      <h2 class="display-2 mb-3">{{ trans('app.featured_ads_title', null, '...') }}</h2>
    </v-container>
    <v-container class="py-10">
      <div class="text-center py-5 my-5" v-if="loading">
        <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
      </div>

      <div v-show="loaded" class="swiper-container pa-1" ref="swiper">
        <div class="swiper-wrapper" v-if="collection && collection.length > 0">
          <div class="swiper-slide fill-height" v-for="item,i in collection" :key="i">
            <advert-item v-bind="item" @click.self="viewItem" :can_favorite="false">
              <v-btn
                text
                color="primary"
                @click.stop="viewItem"
              >{{ trans('app.show_details', null, '...') }}</v-btn>
            </advert-item>
          </div>
        </div>
        <div class="text-center" v-else>No properties</div>
        <div class="swiper-pagination"></div>

        <!-- <div class="swiper-nav fill-height">
					<v-container class="swiper-nav-container">
						<v-btn @click="prevSlide" small fab light absolute left class="swiper-nav-btn prev" color="white">
							<v-icon small>mdi-chevron-left</v-icon>
						</v-btn>
						<v-btn @click="nextSlide" small fab light absolute right class="swiper-nav-btn next" color="white">
							<v-icon small>mdi-chevron-right</v-icon>
						</v-btn>
					</v-container>
        </div>-->
      </div>
    </v-container>
    <div style="position:absolute;top:50%;width:100%">
      <v-container class="container-nav" style="position:relative">
        <v-btn
          @click="prevSlide"
          small
          fab
          light
          absolute
          left
          class="swiper-nav-btn prev"
          color="primary"
        >
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          @click="nextSlide"
          small
          fab
          light
          absolute
          right
          class="swiper-nav-btn next"
          color="primary"
        >
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
      </v-container>
    </div>
  </section>
</template>

<script>
import api from "../../api";
import geolocation from "../../geolocation";
import _ from "lodash";
import { Swiper, Navigation, Pagination } from "swiper/dist/js/swiper.esm.js";
import AdvertItem from "../AdvertItem";

export default {
  components: {
    "advert-item": AdvertItem
  },

  data: () => ({
    collection: null,
    loading: false,
    loaded: false,
    swiper: null
  }),

  methods: {
    loadSwiper: function() {
      Swiper.use([Pagination]);
      this.swiper = new Swiper(this.$refs.swiper, {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 20,
        autoHeight: false,
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 2
          },
          800: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesPerGroup: 3
          }
        },
        slidesPerGroup: 4,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets"
        }
        // ...
      });

      this.swiper.on("slideChange", () => {
        this.$forceUpdate();
        this.swiper.update();
      });
    },

    prevSlide: function(e) {
      return this.swiper.slidePrev();
    },

    nextSlide: function(e) {
      return this.swiper.slideNext();
    },

    viewItem: function(uuid) {
      return this.$router.push({
        name: "advert-details",
        params: { uuid: uuid }
      });
    }
  },

  created: function() {
    // let user_location_request = geolocation.get();
    this.loading = true;
    // user_location_request
    //   .then(place => {
    //     var east = _.get(place, "geometry.viewport").toJSON().east;
    //     var west = _.get(place, "geometry.viewport").toJSON().west;
    //     var zoom =
    //       11 - Math.round(Math.log(Math.abs(west - east)) / Math.log(2));
    //     let data = {
    //       address_components: _.get(place, "address_components", []),
    //       formatted_address: _.get(place, "formatted_address"),
    //       geometry: {
    //         location: _.get(place, "geometry.location").toJSON(),
    //         viewport: _.get(place, "geometry.viewport").toJSON()
    //       },
    //       place_id: _.get(place, "place_id"),
    //       zoom: zoom
    //     };
    //     let location = Object.assign(
    //       {},
    //       data,
    //       _.get(place, "geometry.viewport").toJSON()
    //     );
    //     // get featured ads based on current location
    //     api.frontpage
    //       .featured(location)
    //       .then(response => {
    //         this.collection = response.data;
    //         this.loaded = true;
    //         if (this.swiper) {
    //           this.$nextTick().then(() => this.swiper.update());
    //         }
    //       })
    //       .catch(error => {
    //         this.loaded = false;
    //       })
    //       .then(() => {
    //         this.loading = false;
    //       });
    //   })
    //   .catch(() => {
    //     // get random ads if user not allow getting his location
    //     api.frontpage
    //       .featured()
    //       .then(response => {
    //         this.collection = response.data;
    //         this.loaded = true;
    //         if (this.swiper) {
    //           this.$nextTick().then(() => this.swiper.update());
    //         }
    //       })
    //       .catch(error => {
    //         this.loaded = false;
    //       })
    //       .then(() => {
    //         this.loading = false;
    //       });
    //   });
    api.frontpage
      .featured()
      .then(response => {
        this.collection = response.data;
        this.loaded = true;
        if (this.swiper) {
          this.$nextTick().then(() => this.swiper.update());
        }
      })
      .catch(error => {
        this.loaded = false;
      })
      .then(() => {
        this.loading = false;
      });
  },

  mounted: function() {
    this.loadSwiper();
  }
};
</script>

<style lang="css" scoped>
.swiper-pagination {
  position: relative;
  margin-top: 20px;
}
.swiper-nav {
  position: absolute;
  width: 100%;
  top: 0px;
  pointer-events: none;
}
.swiper-nav-container {
  position: relative;
  top: 50%;
  margin-top: -20px;
  pointer-events: none;
  padding: 0px;
}
.swiper-nav-btn {
  pointer-events: auto;
  z-index: 2;
}
.swiper-container-autoheight .swiper-slide {
  height: 100%;
}
.v-card--link {
  overflow: hidden;
}
</style>